module.exports = __webpack_public_path__ + "static/media/end_of_lesson.ea65aa0c.svg";